import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { TaskHistory } from '../models/task';

export const TaskHistoryFetch = createAction('[TaskHistory] Fetch', props<{ workspaceId: string; taskId: string }>());
export const TaskHistoryFetched = createAction(
  '[TaskHistory] Fetched',
  props<{ taskHistory: TaskHistory[]; taskId: string }>()
);
export const TaskHistoryError = createAction('[TaskHistory] Error', props<{ taskId: string }>());

export const initialState: Record<string, CommonApiState<TaskHistory[]>> = {};

export const taskHistoryFeature = createFeature({
  name: 'taskHistory',
  reducer: createReducer(
    initialState,
    on(TaskHistoryFetch, (state, action) => ({
      ...state,
      [action.taskId]: {
        ...(state[action.taskId] ?? {}),
        currentPedingApis: (state[action.taskId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(TaskHistoryFetched, (state, action) => {
      return {
        ...state,
        [action.taskId]: {
          ...(state[action.taskId] ?? {}),
          currentPedingApis: 0,
          data: action.taskHistory
        }
      };
    }),
    on(TaskHistoryError, (state, action) => {
      return {
        ...state,
        [action.taskId]: {
          ...(state[action.taskId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectTaskHistoryState }) => {
    const taskHistoryIsLoading = (taskId: string) =>
      createSelector(selectTaskHistoryState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) > 0);

    const taskHistoryHasPendingRequest = (taskId: string) =>
      createSelector(selectTaskHistoryState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) >= 2);
    const taskHistoryData = (taskId: string) => {
      return createSelector(selectTaskHistoryState, taskHistoryState => {
        return taskHistoryState[taskId]?.data;
      });
    };

    return { taskHistoryIsLoading, taskHistoryHasPendingRequest, taskHistoryData };
  }
});
